<template>
  <div>
    <h2>audio player</h2>
    <audio ref="plyr" class="plyr" id="player" playsinline controls></audio>
  </div>
</template>

<script>
// import appVideoPlayer from "../components/videoPlayer/VideoPlayer.vue";
import Plyr from "plyr";
import "plyr/dist/plyr.css";

export default {
  components: {},
  props: {
    autoPlay: Boolean,
    hideVolume: Boolean,
  },
  data() {
    return {
      trackNumber: 0,
      sampleVideo: require("../assets/Asl Sample Video-8.mp4"),
      player: {},
      playerType: "audio",
      options: {
        controls: [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
        ],
      },
    };
  },
  mounted() {
    if (this.hideVolume) {
      this.removeVoumeControls();
    }

    this.player = new Plyr(this.$refs.plyr, this.options);
    const _this = this;
    console.log("Balls");
    //player.addEventListener("ended", _this.ended);

    this.setSource(this.playList[this.trackNumber], "video/mp4");
    this.player.on("ended", _this.ended);
  },
  methods: {
    ended(evt) {
      console.log(evt);
      ++this.trackNumber;
      if (this.trackNumber < this.playList.length) {
        this.player.pause();
        this.setSource(this.audio, "video/mp4");
        this.player.play();
      } else {
        this.player.pause();
        this.trackNumber = 0;
        this.setSource(this.audio, "video/mp4");
      }
    },
    setSource(sourceFile, type) {
      this.player.source = {
        type: this.playerType,
        sources: [{ src: sourceFile, type: type }],
      };
    },
    removeVoumeControls() {
      this.options.controls = this.options.controls.filter(
        (r) => r !== "mute" && r !== "volume"
      );
    },
  },
  computed: {
    playList() {
      //return [this.sampleVideo];
      return [
        "https://txadltstestmedia.azureedge.us/media/dev/audio/en/Q0440_eng_1.mp3?sv=2020-08-04&se=2021-11-30T18%3A38%3A54Z&sr=c&sp=r&sig=OafDqwHPtFvCfmkVQB9OPbburB0%2Fa8D902U8UTLHqf8%3D",
        "https://txadltstestmedia.azureedge.us/media/dev/audio/en/QA_eng_1.mp3?sv=2020-08-04&se=2021-11-30T18%3A38%3A54Z&sr=c&sp=r&sig=OafDqwHPtFvCfmkVQB9OPbburB0%2Fa8D902U8UTLHqf8%3D",
        "https://txadltstestmedia.azureedge.us/media/dev/audio/en/Q0440_eng_2.mp3?sv=2020-08-04&se=2021-11-30T18%3A38%3A54Z&sr=c&sp=r&sig=OafDqwHPtFvCfmkVQB9OPbburB0%2Fa8D902U8UTLHqf8%3D",
        "https://txadltstestmedia.azureedge.us/media/dev/audio/en/QB_eng_1.mp3?sv=2020-08-04&se=2021-11-30T18%3A38%3A54Z&sr=c&sp=r&sig=OafDqwHPtFvCfmkVQB9OPbburB0%2Fa8D902U8UTLHqf8%3D",
        "https://txadltstestmedia.azureedge.us/media/dev/audio/en/Q0440_eng_4.mp3?sv=2020-08-04&se=2021-11-30T18%3A38%3A54Z&sr=c&sp=r&sig=OafDqwHPtFvCfmkVQB9OPbburB0%2Fa8D902U8UTLHqf8%3D",
        "https://txadltstestmedia.azureedge.us/media/dev/audio/en/QC_eng_1.mp3?sv=2020-08-04&se=2021-11-30T18%3A38%3A54Z&sr=c&sp=r&sig=OafDqwHPtFvCfmkVQB9OPbburB0%2Fa8D902U8UTLHqf8%3D",
        "https://txadltstestmedia.azureedge.us/media/dev/audio/en/Q0440_eng_5.mp3?sv=2020-08-04&se=2021-11-30T18%3A38%3A54Z&sr=c&sp=r&sig=OafDqwHPtFvCfmkVQB9OPbburB0%2Fa8D902U8UTLHqf8%3D",
        "https://txadltstestmedia.azureedge.us/media/dev/audio/en/QD_eng_1.mp3?sv=2020-08-04&se=2021-11-30T18%3A38%3A54Z&sr=c&sp=r&sig=OafDqwHPtFvCfmkVQB9OPbburB0%2Fa8D902U8UTLHqf8%3D",
        "https://txadltstestmedia.azureedge.us/media/dev/audio/en/Q0440_eng_3.mp3?sv=2020-08-04&se=2021-11-30T18%3A38%3A54Z&sr=c&sp=r&sig=OafDqwHPtFvCfmkVQB9OPbburB0%2Fa8D902U8UTLHqf8%3D",
      ];
    },
    audio() {
      return this.playList[this.trackNumber];
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap");
.plyr {
  width: 480px !important;
  --plyr-audio-controls-background: #424242;
  --plyr-line-height: 4;
  --plyr-audio-control-color: #fff;
  --plyr-color-main: silver;
  --plyr-control-icon-size: 22px;

  --plyr-range-track-height: 8px;
  --plyr-range-thumb-height: 18px;
  --plyr-font-size-base: 18px;
  --plyr-font-size-small: 15px;
  border-radius: 5px;
}

.plyr__volume {
  width: 30% !important;
}
</style>
